import React from 'react';
import { useTranslation } from 'react-i18next';
import { FrameCard, Chip } from '@weezevent/nacre';
import JsonEditorReact from '../../../../components/json-editor/jsonEditor';
import Style from './settings.module.css';

export default function WidgetAdvancedConfiguration({ form, setForm, setIsJsonValid }) {
    const { t } = useTranslation();

    return (
        <FrameCard
            title={
                <div className={Style['advanced-configuration-title']}>
                    <div>{t('ticket.personal_spaces.settings.advanced-configuration.title')}</div>
                    <Chip primary text={t('ticket.common.admin')} icon="user" />
                </div>
            }
        >
            <div className={Style['advanced-configuration-subtitle']}>{t('ticket.personal_spaces.settings.advanced-configuration.subtitle')}</div>
            <JsonEditorReact mode="code" json={form.widget_config} onChange={value => setForm('widget_config', value)} setIsValid={setIsJsonValid} />
        </FrameCard>
    );
}
